module.exports = {
  footerText: `Copyright Stell One © ${new Date().getFullYear()}`,
};
